export class DataFormatter {
  static readonly NUMBER_LOCALE_CONFIG: Intl.NumberFormatOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
  }

  static readonly INTEGER_LOCALE_CONFIG: Intl.NumberFormatOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }

  static readonly CURRENCY_LOCALE_CONFIG: Intl.NumberFormatOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }

  /**
   * Converts a number to a string, replacing '.' with ','
   * @param value
   */
  static numberToString(value: number | string): string {
    if (value === null || value === undefined || value === '') return ''
    return value.toString().replace('.', ',')
  }

  /**
   * Converts a number to a string in the format "1.234,56"
   * @param value The number to convert
   * @param options Configuration object for number formatting
   * @returns The converted string
   */
  static numberToLocaleString(value: number | string, options = this.NUMBER_LOCALE_CONFIG): string {
    if (value === null || value === undefined || value === '') return ''

    const number = typeof value === 'string' ? this.localeStringToNumber(value, options) : value
    return number.toLocaleString('de-DE', options)
  }

  /**
   * Converts a string in the format "1.234,56" to a number 1234.56
   * @param value The string to convert
   * @param options Configuration object for number formatting
   * @returns The converted number
   */
  static localeStringToNumber(value: string, options = this.NUMBER_LOCALE_CONFIG): number {
    if (!value) return 0

    const [int, dec] = value.replaceAll('.', '').split(',')
    const formattedString = `${int}.${this.getFormattedDecimalPlaces(dec ?? '0', options)}`
    return Number(formattedString)
  }

  private static getFormattedDecimalPlaces(
    dec: string | number,
    { maximumFractionDigits } = this.NUMBER_LOCALE_CONFIG
  ): string {
    const decimalString = dec.toString()
    if (maximumFractionDigits === undefined) {
      return decimalString
    }

    return decimalString.length > maximumFractionDigits ? decimalString.slice(0, maximumFractionDigits) : decimalString
  }
}
